import type { ComponentType } from "react";
import { Focusable } from "react-aria-components";
import { Tooltip } from "@/components/base/tooltip/tooltip";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

// Must not use Radix's `disabled` prop: it drops the item from focus order, so the
// tooltip stops being reachable by keyboard. `Focusable` claims the tooltip's anchor ref.
export const DisabledActionMenuItem = ({
  icon: Icon,
  label,
  tooltip,
}: {
  icon: ComponentType<{ className?: string }>;
  label: string;
  tooltip: string;
}) => (
  <Tooltip title={tooltip} placement="left">
    <Focusable>
      <DropdownMenuItem
        aria-disabled
        onSelect={(e) => e.preventDefault()}
        className="flex items-center gap-2 py-2 opacity-50 cursor-not-allowed"
      >
        <Icon className="w-4 h-4 text-fg-quaternary shrink-0" />
        <span className="text-secondary font-semibold">{label}</span>
      </DropdownMenuItem>
    </Focusable>
  </Tooltip>
);
